export const defaultValidationStateValues = {
  pristine: true,
  dirty: false,
  untouched: true,
  touched: false,
  valid: true,
  invalid: false,
  errors: []
};
export const defaultValidationFieldValues = {
  value: void 0,
  validators: []
};
export const reservedValidationFields = [
  "value",
  "validators",
  "pristine",
  "dirty",
  "untouched",
  "touched",
  "valid",
  "invalid",
  "errors"
];
